import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { initSentry, SentryConfig } from '../lib/sentry';

interface SentryContextType {
  isInitialized: boolean;
}

const SentryContext = createContext<SentryContextType | undefined>(undefined);

export const useSentry = () => {
  const context = useContext(SentryContext);
  if (context === undefined) {
    throw new Error('useSentry must be used within a SentryProvider');
  }
  return context;
};

interface SentryProviderProps {
  children: ReactNode;
  config: SentryConfig;
}

export const SentryProvider: React.FC<SentryProviderProps> = ({ children, config }) => {
  const [isInitialized, setIsInitialized] = React.useState(false);

  useEffect(() => {
    try {
      initSentry(config);
      setIsInitialized(true);
    } catch (error) {
      console.error('[SentryProvider] Failed to initialize Sentry:', error);
    }
  }, []);

  return (
    <SentryContext.Provider value={{ isInitialized }}>
      {children}
    </SentryContext.Provider>
  );
};
